import { messaging } from 'lib/axios';
import { useQuery } from 'react-query';

export const getGlobalConversation = () => {
  const data = messaging.get('/conversations/global');

  return data;
};

export const useGlobalConversation = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['global_conversation'],
    queryFn: () => getGlobalConversation(),
  });
};
